import { React, useEffect, useState, useRef, useLayoutEffect } from "react";

import Navbar from "../components/Navbar/Navbar";
import Footer from "./Footer/Footer";
import { useDispatch, useSelector } from "react-redux";

import { getProfilePic } from "../components/Helpers/Common";
import styled, { ThemeProvider, useTheme } from "styled-components";
import { getUserTheme } from "../redux/actions/auth";
import { Page, themes, defaultTheme, pageBackground } from "./Theme";
import Loader from "../components/Button/Loader";
import $ from "jquery";
import ModalChatBot from "../components/Modal/ModalChatBot";
import ChatBotIcon from "../common/images-new/ChatBotIcon.svg";
import NavbarHeader from "../components/Navbar/NewNavbarHeader";
import { lighten, mix, transparentize } from "polished";
let dataTheme = {};
let loading = true;

const Index = ({
  hideNav,
  isGuest,
  tempTheme,
  present,
  isShowCase = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const userTheme = useSelector((state) => state.auth.theme);
  // let userTheme = {};
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);

  const isNavShown = hideNav === true ? false : true;
  const isPublicPage = isGuest === true;
  const profilePhoto = getProfilePic(user ? user.photo : null);
  // const [theme, setTheme] = useState('light')
  const [theme, setTheme] = useState({});
  const [showChatBot, setShowChatBot] = useState(false);
  const chatBotRef = useRef(null);
  const isUserDetails = useSelector((state) => state.auth.user);
  const root = document.documentElement;
  const isThemeLoader = useSelector((state) => state.auth.isThemeLoader);
  useEffect(() => {
    if (!tempTheme && tempTheme?.length === 0) {
      dispatch(getUserTheme());
    }
  }, []);

  // useLayoutEffect(() => {
  //     setInterval(() => {
  //         loading = localStorage.getItem("themeLoader") == 'true' ? true : false;
  //         if (loading === true) {
  //             $("#loaderHide").removeClass("hidden");
  //             $("#themeDiv").addClass("hidden");
  //         } else {
  //             $("#loaderHide").addClass("hidden");
  //             $("#themeDiv").removeClass("hidden");
  //         }
  //     }, 100)
  // }, [])

  useEffect(() => {
    if (tempTheme === undefined || tempTheme === null || tempTheme === "") {
      if (isDefaultTheme == false) {
        dataTheme = {
          pageBackground: userTheme?.color1 ? userTheme?.color1 : "#F7F8FA",
          blue: userTheme?.color2 ? userTheme?.color2 : "#0054A6",
          darkBlue: userTheme?.color3 ? userTheme?.color3 : "#31658e",
          white: userTheme?.color4 ? userTheme?.color4 : "white",
          black: userTheme?.color5 ? userTheme?.color5 : "#111822",
          gray: userTheme?.color6 ? userTheme?.color6 : "#9ca3af",
          lightGray: userTheme?.color7 ? userTheme?.color7 : "#969696",
          deleteRed: userTheme?.color2 ? userTheme?.color2 : "#DC2626",
          green: userTheme?.color8 ? userTheme?.color8 : "#66D692",
          navBg: userTheme?.color3 ? userTheme?.color3 : "white",
          navText: userTheme?.color2 ? userTheme?.color2 : "black",
          liDivColor: userTheme?.color2 ? userTheme?.color2 : "black",
          liDivColorHover: userTheme?.color7 ? userTheme?.color7 : "#969696",
          buttonTopColor: "white",
          modalInActiveBgColor: userTheme?.color4 ? userTheme?.color4 : "white",
          modalInActiveColor: userTheme?.color6 ? userTheme?.color6 : "Black",
          BorderColor: userTheme?.color6 ? userTheme?.color6 : "gray",
          ButtonGreenBgColor: userTheme?.color4 ? userTheme?.color4 : "#66d693",
          ButtonGreenColor: userTheme?.color6 ? userTheme?.color6 : "white",
          ButtonGreenHoverColor: userTheme?.color7
            ? userTheme?.color7
            : "#00b050",
          ButtonThemeGreen: userTheme?.color5 ? userTheme?.color5 : "#66d693",
          ButtonThemeBgGreen: userTheme?.color6
            ? userTheme?.color6
            : "rgba(209, 213, 219)",
          PubishIcon: userTheme?.color8 ? userTheme?.color8 : "black",
          sortIcon: userTheme?.color6 ? userTheme?.color6 : "#2084D4",
          //New Code
          NavBarColor: userTheme?.color2 ? userTheme?.color2 : "#FFFFFF",
          iconGreen: userTheme?.color2 ? userTheme?.color2 : "#059669",
          iconBlue: userTheme?.color2 ? userTheme?.color2 : "#2563eb",
          preferenceBg: userTheme?.color2 ? userTheme?.color2 : "#f9fafb",
          preferenceText: userTheme?.color2 ? userTheme?.color2 : "#111822",
        };
        root.style.setProperty(
          "--varBackgroundColor",
          userTheme?.color1 ? userTheme?.color1 : "#F7F8FA"
        );
        root.style.setProperty(
          "--varBlueColor",
          userTheme?.color2 ? userTheme?.color2 : "#0054A6"
        );
        root.style.setProperty(
          "--varDarkBlueColor",
          userTheme?.color3 ? userTheme?.color3 : "#31658e"
        );
        root.style.setProperty(
          "--varCardBackgroundColor",
          userTheme?.color4 ? userTheme?.color4 : "#FFFFFF"
        );
        root.style.setProperty(
          "--varBlackColor",
          userTheme?.color5 ? userTheme?.color5 : "#111822"
        );
        root.style.setProperty(
          "--varGreyColor",
          userTheme?.color6 ? userTheme?.color6 : "#9ca3af"
        );
        root.style.setProperty(
          "--varLightColor",
          userTheme?.color7 ? userTheme?.color7 : "#969696"
        );
        root.style.setProperty(
          "--varGreenColor",
          userTheme?.color8 ? userTheme?.color8 : "#F7F8FA"
        );
        root.style.setProperty(
          "--varDeleteRed",
          userTheme?.color2 ? userTheme?.color2 : "#DC2626"
        );

        root.style.setProperty(
          "--varNavBarColor",
          userTheme?.color2 ? userTheme?.color2 : "#FFFFFF"
        );
        root.style.setProperty(
          "--varNavBarColorPresent",
          userTheme?.color2
            ? mix(
                0.60,
                userTheme?.color4 ? userTheme?.color4 : "#ffffff",
                userTheme?.color2
              )
            : "#FFFFFF"
        );
        root.style.setProperty(
          "--varNavBarActiveColor",
          userTheme?.color3 ? userTheme?.color3 : "#0054A6"
        );
        root.style.setProperty(
          "--varNavBarInActiveColor",
          userTheme?.color5 ? userTheme?.color5 : "#111822"
        );

        root.style.setProperty(
          "--varPirmaryIcon",
          userTheme?.color2 ? userTheme?.color2 : "#0054A6"
        );
        root.style.setProperty(
          "--varSecondaryIcon",
          userTheme?.color6 ? userTheme?.color6 : "#9ca3af"
        );

        root.style.setProperty(
          "--varIconGreen",
          userTheme?.color2 ? userTheme?.color2 : "#059669"
        );
        root.style.setProperty(
          "--varIconBlue",
          userTheme?.color2 ? userTheme?.color2 : "#2563eb"
        );

        root.style.setProperty(
          "--varPreferenceBg",
          userTheme?.color2 ? userTheme?.color2 : "#f9fafb"
        );
        root.style.setProperty(
          "--varPreferenceText",
          userTheme?.color2 ? userTheme?.color2 : "#111822"
        );
      } else {
        dataTheme = defaultTheme;
        root.style.setProperty("--varBackgroundColor", "#F7F8FA");
        root.style.setProperty("--varBlueColor", "#0054A6");
        root.style.setProperty("--varDarkBlueColor", "#31658e");
        root.style.setProperty("--varCardBackgroundColor", "#FFFFFF");
        root.style.setProperty("--varBlackColor", "#111822");
        root.style.setProperty("--varGreyColor", "#9ca3af");
        root.style.setProperty("--varLightColor", "#969696");
        root.style.setProperty("--varGreenColor", "#66D692");
        root.style.setProperty("--varDeleteRed", "#DC2626");

        root.style.setProperty("--varNavBarColor", "#FFFFFF");
        root.style.setProperty("--varNavBarColorPresent", "#FFFFFF");
        root.style.setProperty("--varNavBarActiveColor", "#0054A6");
        root.style.setProperty("--varNavBarInActiveColor", "#111822");

        root.style.setProperty("--varPirmaryIcon", "#0054A6");
        root.style.setProperty("--varSecondaryIcon", "#9ca3af");

        root.style.setProperty("--varIconGreen", "#059669");
        root.style.setProperty("--varIconBlue", "#2563eb");
        root.style.setProperty("--varPreferenceBg", "#f9fafb");
        root.style.setProperty("--varPreferenceText", "#111822");
      }
      setTheme(dataTheme);
    }
  }, [userTheme, isDefaultTheme]);

  useEffect(() => {
    setInterval(() => {
      const elements = document.getElementsByClassName("swal2-popup");
      const checks = document.getElementsByClassName("checkGreen");
      if (elements?.length > 0 && dataTheme) {
        Array.from(elements).forEach((element) => {
          element.style.setProperty("--bg-swal-color", dataTheme?.white);
          element.style.setProperty("--icon-swal-color", dataTheme?.blue);
          element.style.setProperty("--title-swal-color", dataTheme?.black);
          element.style.setProperty("--html-swal-color", dataTheme?.gray);
          element.style.setProperty(
            "--button-swal-color",
            dataTheme?.buttonTopColor
          );
        });
      }
      if (checks?.length > 0 && dataTheme) {
        Array.from(checks).forEach((element) => {
          element.style.setProperty(
            "--buttonColor",
            dataTheme?.ButtonThemeGreen
          );
          element.style.setProperty(
            "--buttonBgColor",
            dataTheme?.ButtonThemeBgGreen
          );
          element.style.setProperty("--icon-swal-color", dataTheme?.blue);
        });
      }
    }, 1);
  }, []);

  // for edit layout
  useEffect(() => {
    if (tempTheme && tempTheme.length !== 0) {
      dataTheme = tempTheme;
      setTheme(dataTheme);
    }
  }, [tempTheme]);

  // useEffect(() => {
  //     if(userTheme && userTheme.length > 0){
  //         // let filteredTheme = userThemes.filter((item) => item.key === 'theme')
  //         // todo: filter based on user id
  //         setTheme(userTheme)
  //         // setTheme(filteredTheme[0].value)

  //     }
  // }, [userTheme])

  return (
    <>
      {/* {isThemeLoader && <Loader loading={isThemeLoader} />} */}
      {/* <div className="hidden" id="loaderHide">

        </div> */}
      <div className="" id="">
        <ThemeProvider theme={theme}>
          <Page>
            {!present && (
              <>
                <NavbarHeader
                  profilePhoto={profilePhoto}
                  username={user ? user.fullname : ""}
                  email={user ? user.email : ""}
                  guid={user?.guid ? user?.guid : ""}
                  isNavShown={isNavShown}
                  programme_category={
                    user?.programme_category ? user?.programme_category : ""
                  }
                />
                {/* New Header Changes */}
                <div
                  className={`${
                    isShowCase
                      ? ""
                      : "px-5 md:px-10 lg:px-10 xl:px-10 content containerMaxWidth"
                  }`}
                >
                  <div className="pt-4">{props.children}</div>
                </div>
              </>
            )}
            {present && props.children}
            {/* </> : <>
                            <Navbar
                                profilePhoto={profilePhoto}
                                username={user ? user.fullname : ''}
                                email={user ? user.email : ''}
                                guid={user?.guid ? user?.guid : ''}
                                isNavShown={isNavShown}
                            />
                            {
                                props.children
                            }
                        </> 
                     */}
            {!present && (
              <>
                <Footer publicPage={isPublicPage} />
                {/* Chat Bot UI */}
                {isNavShown && isUserDetails?.chatbot_id != null && (
                  <div className="chatbot-container">
                    <img
                      src={ChatBotIcon}
                      alt="Chatbot Icon"
                      ref={chatBotRef}
                      className="cursor-pointer w-12 chatbot-icon"
                      onClick={() => setShowChatBot(!showChatBot)}
                    />
                    <button
                      className="chatbot-button"
                      onClick={() => setShowChatBot(!showChatBot)}
                    >
                      Got a Question?
                    </button>
                    <ModalChatBot
                      handleClose={() => setShowChatBot(false)}
                      show={showChatBot}
                      anchorEl={chatBotRef.current}
                      chatbot_id={isUserDetails?.chatbot_id}
                    />
                  </div>
                )}
                {/* End chat Bot UI */}
              </>
            )}
          </Page>
        </ThemeProvider>
      </div>
    </>
  );
};

export default Index;
